import axios from "../config/axios";

export async function leerUltimosDocumentos(data) {
  let clases = null;
  if (data.clases) {
    if (data.clases.length === 1) {
      clases = data.clases[0];
    } else {
      clases = data.clases.join(",");
    }
  }
  return await axios.get(`documentos_v2/api/v3/leer_documentos`, {
    params: {
      documento: data.documento,
      limite: data.limite,
      clases: clases
    }
  });
}

export async function obtenerOpcionesDocumentos() {
  return await axios.get("documentos_v2/api/v3/leer_opciones");
}

export async function crearDocumentoInactivo(data) {
  return await axios.post(`documentos_v2/api/v3/crear`, {
    tipo_esquema: data.tipo_esquema,
    documento: data.documento,
    creado_por: data.creado_por,
    origen: data.origen,
    id: data.id,
    momento: data.momento
  });
}

export async function leerDocumento(data) {
  return await axios.get(`documentos_v2/api/v3/leer`, {
    params: {
      tipo_esquema: data.tipo_esquema,
      docId: data.docId
    }
  });
}

export async function borrarDocumentoInactivo(data) {
  return await axios.delete(`documentos_v2/api/v3/borrar/${data.docId}`);
}

export async function actualizarArchivoEnDocumento(data) {
  var formData = new FormData();
  const {
    archivo,
    tipo_esquema,
    docId,
    documento,
    creado_por,
    variable5
  } = data;
  formData.append("archivo", archivo);
  formData.append("tipo_esquema", tipo_esquema);
  formData.append("docId", docId);
  formData.append("documento", Number(documento));
  formData.append("creado_por", creado_por);
  formData.append("variable5", variable5);
  return await axios({
    method: "PUT",
    url: "documentos_v2/api/v3/actualizar_archivo",
    data: formData,
    config: {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  });
}

export async function leerArchivo(data) {
  return await axios.get(`documentos_v2/api/v3/leer_archivo`, {
    params: {
      docId: data.docId
    }
  });
}

export async function leerDocumentosAsociados(data) {
  return await axios.get(`documentos_v2/api/v3/leer_asociados`, {
    params: {
      id: data.id,
      origen: data.origen
    }
  });
}
// funcion para subir ordenes masivas.
// @param {objeto} formData
//

export async function subirDocumentoOrdenes(formData) {
  return await axios({
    method: "POST",
    url:
      "gestion_ordenes_consultas/gestion_ordenes/api/v1/carga_ordenes_masivas",
    data: formData,
    config: {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/apiService/request/CrudDocumentos.js